/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Questionnaire_Exitquestionnaire1Inputs */

const en_questionnaire_exitquestionnaire1 = /** @type {(inputs: Questionnaire_Exitquestionnaire1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exit questionnaire`)
};

const fr_questionnaire_exitquestionnaire1 = /** @type {(inputs: Questionnaire_Exitquestionnaire1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitter le questionnaire`)
};

/**
* | output |
* | --- |
* | "Exit questionnaire" |
*
* @param {Questionnaire_Exitquestionnaire1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const questionnaire_exitquestionnaire1 = /** @type {((inputs?: Questionnaire_Exitquestionnaire1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Questionnaire_Exitquestionnaire1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_questionnaire_exitquestionnaire1(inputs)
	return fr_questionnaire_exitquestionnaire1(inputs)
});
export { questionnaire_exitquestionnaire1 as "questionnaire_exitQuestionnaire" }